import React, { useCallback } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(0.5)
  },
  title: {
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.spacing(2.5),
    lineHeight: 1.6,
    fontFamily: theme.typography.h6.fontFamily
  },
  content: {
    color: theme.palette.text.secondary
  },
  actions: {
    padding: theme.spacing(1.5)
  }
}));

type RemoveEntryDialogProps = {
  open: boolean;
  removeEntry: () => void;
  closeHandler: () => void;
};

export const RemoveEntryDialog: React.FC<RemoveEntryDialogProps> = ({
  removeEntry,
  open,
  closeHandler
}: RemoveEntryDialogProps) => {
  const classes = useStyles();
  const onRemoveClick = useCallback(() => {
    removeEntry();
    closeHandler();
  }, [closeHandler, removeEntry]);
  return (
    <Dialog
      open={open}
      className={classes.dialog}
      maxWidth="sm"
      data-testid="split-remove-confirmation-dialog"
    >
      <DialogTitle className={classes.title}>
        <FormattedMessage id="note.split.removeTitle" />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText>
          <FormattedMessage id="note.split.removeMessage1" />
        </DialogContentText>
        <DialogContentText>
          <FormattedMessage id="note.split.removeMessage2" />
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onRemoveClick}
          data-testid="split-remove-confirmation-dialog-remove"
          color="secondary"
        >
          <FormattedMessage id="note.split.remove" />
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={closeHandler}
          data-testid="split-remove-confirmation-dialog-cancel"
        >
          <FormattedMessage id="note.split.cancel" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
